export default "__VITE_ASSET__BzdlWAMl__"